/**
 * <p-brand-comparison> — Mobile-Umschalter der Section „Markenvergleich" (sections/brand-comparison.liquid).
 * Ersetzt das Inline-Script aus Hyper 1:1: Klick auf [data-bcmp-tab="a|b"] zeigt Bild + Panel der
 * gewählten Spalte (Klasse is-active) und markiert den passenden Button in beiden Slides.
 * Kein Section-Reload-Handling nötig: der Theme-Editor ersetzt das Element, connectedCallback läuft neu.
 */
if (!customElements.get('p-brand-comparison')) {
  class PBrandComparison extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick = (event) => {
      const button = event.target.closest('[data-bcmp-tab]');
      if (button) this.activate(button.dataset.bcmpTab);
    };

    activate(which) {
      const isA = which === 'a';
      this.querySelectorAll('[data-bcmp-tab]').forEach((button) => {
        const active = button.dataset.bcmpTab === which;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      this.querySelectorAll('[data-bcmp-pane="a"]').forEach((el) => el.classList.toggle('is-active', isA));
      this.querySelectorAll('[data-bcmp-pane="b"]').forEach((el) => el.classList.toggle('is-active', !isA));
    }
  }

  customElements.define('p-brand-comparison', PBrandComparison);
}
